import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every route change.
 *
 * Must live INSIDE <BrowserRouter> so `useLocation()` is available.
 * Renders nothing.
 *
 * If the URL contains a `#hash`, we let the browser handle its native
 * scroll-to-anchor behaviour instead of forcing top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Use `auto` (instant) - smooth scrolling here feels laggy on route
    // transitions and the user just clicked a link expecting a new page.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
